import type { RouterOnChangeArgs } from 'preact-router'
import { Router } from 'preact-router'
import '../styles/global.css'
import '../styles/nodes.css'
import { Analytics } from './Analytics.js'
import { Header } from './components/index.js'
import { Changelog, Convert, Customized, Generator, Generators, Guide, Guides, Home, LegacyPartners, Partners, Sounds, Transformation, Versions, WhatsNew, Worldgen } from './pages/index.js'
import { cleanUrl } from './Utils.js'

export function App() {
	const changeRoute = (e: RouterOnChangeArgs) => {
		window.dispatchEvent(new CustomEvent('replacestate'))
		// Needs a timeout to ensure the title is set correctly
		setTimeout(() => Analytics.pageview(cleanUrl(e.url)))
	}

	return <>
		<Header />
		<Router onChange={changeRoute}>
			<Home path="/datapack-generator/" />
			<Generators path="/datapack-generator/generators" />
			<Worldgen path="/datapack-generator/worldgen" />
			<Partners path="/datapack-generator/partners" />
			<LegacyPartners path="/datapack-generator/partners/:id" />
			<Sounds path="/datapack-generator/sounds" />
			<Changelog path="/datapack-generator/changelog" />
			<Versions path="/datapack-generator/versions" />
			<Transformation path="/datapack-generator/transformation" />
			<Customized path="/datapack-generator/customized" />
			<Convert path="/datapack-generator/convert" />
			<Convert path="/datapack-generator/convert/:formats" />
			<WhatsNew path="/datapack-generator/whats-new" />
			<Guides path="/datapack-generator/guides" />
			<Guide path="/datapack-generator/guides/:id" />
			<Generator default />
		</Router>
	</>
}
